import { render, staticRenderFns } from "./Gantt.vue?vue&type=template&id=42dd3902"
import script from "./Gantt.vue?vue&type=script&lang=js"
export * from "./Gantt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42dd3902')) {
      api.createRecord('42dd3902', component.options)
    } else {
      api.reload('42dd3902', component.options)
    }
    module.hot.accept("./Gantt.vue?vue&type=template&id=42dd3902", function () {
      api.rerender('42dd3902', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/Gantt.vue"
export default component.exports